// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Team picking intro. The card is a full-bleed marquee item: a neutral field
 * that splits into the two team panels while the player chips fly from a
 * single centered stack into their team's column.
 *
 * Positions are all derived from CSS variables set by the component:
 *   --rows   number of rows in the tallest stack (all players, then the
 *            bigger team once split)
 *   --i      a chip's row within its current stack
 *   --order  a chip's index in the player list, used to stagger animations
 */
.teamPicker {
  --stage-h: calc(var(--content-height) - 9rem);
  /* Rows shrink to fit when there are lots of players; chips follow. */
  --row: min(4.4rem, calc(var(--stage-h) / var(--rows)));
  --chip-h: clamp(2.6rem, calc(var(--row) - 0.5rem), 3.75rem);

  position: relative;
  width: calc(var(--global-width) - 4rem);
  max-width: calc(100vw - 4rem);
  height: var(--content-height);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background: var(--sky-soft);
  overflow: hidden;
}

/* ---- Team panels wipe out from the centre line ---- */

.teamPicker .teamPanel {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 50%;
  transform: scaleX(0);
  transition: transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);
}

.teamPicker .teamPanel.team1 {
  left: 0;
  background: var(--team1-panel);
  transform-origin: right center;
}

.teamPicker .teamPanel.team2 {
  right: 0;
  background: var(--team2-panel);
  transform-origin: left center;
}

.teamPicker.split .teamPanel {
  transform: scaleX(1);
}

/* ---- Headline ---- */

.pickHeader {
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  padding: 1.75rem 1rem 0;
  text-align: center;
}

.teamPicker .pickHeader p.pickTitle {
  margin: 0;
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 3rem;
  line-height: 1.15;
  color: var(--ink);
}

.teamPicker.settled .pickHeader p.pickTitle {
  animation: pickTitlePop 0.45s var(--bounce-effect) both;
}

@keyframes pickTitlePop {
  from {
    transform: scale(0.82);
    opacity: 0.4;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

/* ---- Stage: team titles and player chips ---- */

.pickStage {
  position: relative;
  z-index: 1;
  flex: 1;
  min-height: 0;
}

.pickTeamTitle {
  position: absolute;
  top: 50%;
  width: 50%;
  margin: 0;
  padding: 0 1rem;
  box-sizing: border-box;
  text-align: center;
  font-size: 2.2rem;
  line-height: 1.1;
  /* Sit just above the top of the column. */
  transform: translateY(calc(-50% - ((var(--rows) / 2) * var(--row)) - 1.6rem));
  opacity: 0;
  transition: opacity 0.4s ease 0.45s, transform 0.85s var(--bounce-effect);
}

.pickTeamTitle.team1 {
  left: 0;
  color: var(--team1-text);
}

.pickTeamTitle.team2 {
  left: 50%;
  color: var(--team2-text);
}

.teamPicker.split .pickTeamTitle {
  opacity: 1;
}

/* Each chip is a half-width column that starts centred; the split shifts it
   half its own width left or right, i.e. onto its team's half. */
.pickChip {
  position: absolute;
  top: 50%;
  left: 25%;
  width: 50%;
  margin-top: calc(var(--chip-h) / -2);
  display: flex;
  justify-content: center;
  transform: translate(
    var(--tx, 0),
    calc((var(--i) - (var(--rows) - 1) / 2) * var(--row))
  );
  transition: transform 0.85s var(--bounce-effect);
  transition-delay: calc(var(--order) * 70ms);
}

.teamPicker.split .pickChip.team1 {
  --tx: -50%;
}

.teamPicker.split .pickChip.team2 {
  --tx: 50%;
}

.pickChipCard {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  width: 19rem;
  max-width: calc(100% - 1.5rem);
  height: var(--chip-h);
  padding: 0.3rem 1.1rem 0.3rem 0.3rem;
  box-sizing: border-box;
  background: var(--white);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-card);
  transition: height 0.85s var(--bounce-effect);
  animation: pickChipIn 0.45s var(--bounce-effect) both;
  animation-delay: calc(var(--order) * 60ms);
}

@keyframes pickChipIn {
  from {
    transform: scale(0.6);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.pickChipCard .avatar {
  width: calc(var(--chip-h) - 0.6rem);
  height: calc(var(--chip-h) - 0.6rem);
  font-size: calc(var(--chip-h) * 0.42);
  transition:
    background-color 0.4s ease 0.5s,
    color 0.4s ease 0.5s,
    width 0.85s var(--bounce-effect),
    height 0.85s var(--bounce-effect);
}

.pickChipName {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.55rem;
  line-height: 1.2;
  color: var(--ink);
}

@media (max-width: 600px) {
  .teamPicker .pickHeader p.pickTitle {
    font-size: 2rem;
  }

  .pickTeamTitle {
    font-size: 1.4rem;
  }

  .pickChipCard {
    width: 11rem;
  }

  .pickChipName {
    font-size: 1.15rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/browser/webapp/components/room/marquees/team-picker.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE;AACF;EACE,6CAA6C;EAC7C,qEAAqE;EACrE,sDAAsD;EACtD,2DAA2D;;EAE3D,kBAAkB;EAClB,uCAAuC;EACvC,6BAA6B;EAC7B,6BAA6B;EAC7B,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,wDAAwD;;AAExD;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,OAAO;EACP,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,QAAQ;EACR,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA,uBAAuB;;AAEvB;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,kDAAkD;;AAElD;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,6EAA6E;EAC7E,UAAU;EACV,yEAAyE;AAC3E;;AAEA;EACE,OAAO;EACP,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;iEACiE;AACjE;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB;;;GAGC;EACD,gDAAgD;EAChD,2CAA2C;AAC7C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,qBAAqB;EACrB,oCAAoC;EACpC,sBAAsB;EACtB,wBAAwB;EACxB,mCAAmC;EACnC,8BAA8B;EAC9B,6CAA6C;EAC7C,qDAAqD;EACrD,0CAA0C;AAC5C;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,qCAAqC;EACrC;;;;qCAImC;AACrC;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/*\n * Team picking intro. The card is a full-bleed marquee item: a neutral field\n * that splits into the two team panels while the player chips fly from a\n * single centered stack into their team's column.\n *\n * Positions are all derived from CSS variables set by the component:\n *   --rows   number of rows in the tallest stack (all players, then the\n *            bigger team once split)\n *   --i      a chip's row within its current stack\n *   --order  a chip's index in the player list, used to stagger animations\n */\n.teamPicker {\n  --stage-h: calc(var(--content-height) - 9rem);\n  /* Rows shrink to fit when there are lots of players; chips follow. */\n  --row: min(4.4rem, calc(var(--stage-h) / var(--rows)));\n  --chip-h: clamp(2.6rem, calc(var(--row) - 0.5rem), 3.75rem);\n\n  position: relative;\n  width: calc(var(--global-width) - 4rem);\n  max-width: calc(100vw - 4rem);\n  height: var(--content-height);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  background: var(--sky-soft);\n  overflow: hidden;\n}\n\n/* ---- Team panels wipe out from the centre line ---- */\n\n.teamPicker .teamPanel {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 50%;\n  transform: scaleX(0);\n  transition: transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.teamPicker .teamPanel.team1 {\n  left: 0;\n  background: var(--team1-panel);\n  transform-origin: right center;\n}\n\n.teamPicker .teamPanel.team2 {\n  right: 0;\n  background: var(--team2-panel);\n  transform-origin: left center;\n}\n\n.teamPicker.split .teamPanel {\n  transform: scaleX(1);\n}\n\n/* ---- Headline ---- */\n\n.pickHeader {\n  position: relative;\n  z-index: 1;\n  flex-shrink: 0;\n  padding: 1.75rem 1rem 0;\n  text-align: center;\n}\n\n.teamPicker .pickHeader p.pickTitle {\n  margin: 0;\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 3rem;\n  line-height: 1.15;\n  color: var(--ink);\n}\n\n.teamPicker.settled .pickHeader p.pickTitle {\n  animation: pickTitlePop 0.45s var(--bounce-effect) both;\n}\n\n@keyframes pickTitlePop {\n  from {\n    transform: scale(0.82);\n    opacity: 0.4;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* ---- Stage: team titles and player chips ---- */\n\n.pickStage {\n  position: relative;\n  z-index: 1;\n  flex: 1;\n  min-height: 0;\n}\n\n.pickTeamTitle {\n  position: absolute;\n  top: 50%;\n  width: 50%;\n  margin: 0;\n  padding: 0 1rem;\n  box-sizing: border-box;\n  text-align: center;\n  font-size: 2.2rem;\n  line-height: 1.1;\n  /* Sit just above the top of the column. */\n  transform: translateY(calc(-50% - ((var(--rows) / 2) * var(--row)) - 1.6rem));\n  opacity: 0;\n  transition: opacity 0.4s ease 0.45s, transform 0.85s var(--bounce-effect);\n}\n\n.pickTeamTitle.team1 {\n  left: 0;\n  color: var(--team1-text);\n}\n\n.pickTeamTitle.team2 {\n  left: 50%;\n  color: var(--team2-text);\n}\n\n.teamPicker.split .pickTeamTitle {\n  opacity: 1;\n}\n\n/* Each chip is a half-width column that starts centred; the split shifts it\n   half its own width left or right, i.e. onto its team's half. */\n.pickChip {\n  position: absolute;\n  top: 50%;\n  left: 25%;\n  width: 50%;\n  margin-top: calc(var(--chip-h) / -2);\n  display: flex;\n  justify-content: center;\n  transform: translate(\n    var(--tx, 0),\n    calc((var(--i) - (var(--rows) - 1) / 2) * var(--row))\n  );\n  transition: transform 0.85s var(--bounce-effect);\n  transition-delay: calc(var(--order) * 70ms);\n}\n\n.teamPicker.split .pickChip.team1 {\n  --tx: -50%;\n}\n\n.teamPicker.split .pickChip.team2 {\n  --tx: 50%;\n}\n\n.pickChipCard {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  width: 19rem;\n  max-width: calc(100% - 1.5rem);\n  height: var(--chip-h);\n  padding: 0.3rem 1.1rem 0.3rem 0.3rem;\n  box-sizing: border-box;\n  background: var(--white);\n  border-radius: var(--border-radius);\n  box-shadow: var(--shadow-card);\n  transition: height 0.85s var(--bounce-effect);\n  animation: pickChipIn 0.45s var(--bounce-effect) both;\n  animation-delay: calc(var(--order) * 60ms);\n}\n\n@keyframes pickChipIn {\n  from {\n    transform: scale(0.6);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.pickChipCard .avatar {\n  width: calc(var(--chip-h) - 0.6rem);\n  height: calc(var(--chip-h) - 0.6rem);\n  font-size: calc(var(--chip-h) * 0.42);\n  transition:\n    background-color 0.4s ease 0.5s,\n    color 0.4s ease 0.5s,\n    width 0.85s var(--bounce-effect),\n    height 0.85s var(--bounce-effect);\n}\n\n.pickChipName {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: left;\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1.55rem;\n  line-height: 1.2;\n  color: var(--ink);\n}\n\n@media (max-width: 600px) {\n  .teamPicker .pickHeader p.pickTitle {\n    font-size: 2rem;\n  }\n\n  .pickTeamTitle {\n    font-size: 1.4rem;\n  }\n\n  .pickChipCard {\n    width: 11rem;\n  }\n\n  .pickChipName {\n    font-size: 1.15rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
